export default __webpack_public_path__ + "static/img-6-1ce88e4f75791a251f61f869512200a8.png";